import { render, staticRenderFns } from "./responsible-gaming-modal.vue?vue&type=template&id=9b3276b8&scoped=true&shadowMode"
import script from "./responsible-gaming-modal.ts?vue&type=script&lang=ts&shadowMode"
export * from "./responsible-gaming-modal.ts?vue&type=script&lang=ts&shadowMode"
function injectStyles (context) {
  
  var style0 = require("./responsible-gaming-modal.scss?vue&type=style&index=0&id=9b3276b8&lang=scss&scoped=true&shadowMode")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "9b3276b8",
  null
  ,true
)

component.options.__file = "responsible-gaming-modal.vue"
export default component.exports